/**
 * Concatena root UNC (es. \\NAS\share\Volume_1) con un nome cartella figlia.
 */
export function joinUncDocumentsPath(nasRoot: string, folderName: string): string {
  const root = (nasRoot || '').trim().replace(/[/\\]+$/, '');
  const name = (folderName || '').trim().replace(/^[/\\]+/, '');
  if (!root) return name;
  if (!name) return root;
  const sep = root.includes('\\') ? '\\' : '/';
  return `${root}${sep}${name}`;
}

/** Ultimo segmento del percorso (es. Volume_1 da ...\Public\Volume_1). */
export function uncPathLastSegment(path: string): string {
  const cleaned = (path || '').trim().replace(/[/\\]+$/, '');
  const parts = cleaned.split(/[/\\]/).filter(Boolean);
  return parts[parts.length - 1] ?? '';
}
